module.exports = __webpack_public_path__ + "img/simposio_nov.4c254f7f.webp";